








































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { TagData } from './types'

@Component({})
export default class Tags extends Vue {
  @Prop({ type: Array }) readonly tags!: Array<TagData>

  @Prop({ type: String }) readonly type!: 'modal' | 'link'

  currentHint: null | TagData['hint'] = null

  isOpen = false

  tagName = ''

  chatId = this.$store.state.chatState.chat?.chat_id !== undefined ? this.$store.state.chatState.chat.chat_id : "CHAT_ID"

  @Watch('currentHint')
  hintWatcher(component: null | TagData['hint']): void {
    if (component) {
      this.isOpen = true
    }
  }

  tagClick(tag: TagData): void {
    if (tag.hint) {
      this.currentHint = tag.hint
    } else {
      if (this.type === "modal") {
        this.tagName = tag.text
        this.isOpen = true
      } else if (this.type === "link") {
        this.$router.push({ name: 'buy' })
      }
    }
  }
}
